// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/';
const ROOTS_AUTH = '/auth';

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    statistics: path(ROOTS_DASHBOARD, 'statistics'),
    trial: path(ROOTS_DASHBOARD, 'trial'),
    home: path(ROOTS_DASHBOARD, 'home'),
    qa: path(ROOTS_DASHBOARD, 'qa'),
    tov: path(ROOTS_DASHBOARD, 'tov'),
    settings: path(ROOTS_DASHBOARD, 'settings/general'),
    settingsConnectors: path(ROOTS_DASHBOARD, 'settings/connectors'),
    settingsActions: path(ROOTS_DASHBOARD, 'settings/actions'),
    settingsAutomation: path(ROOTS_DASHBOARD, 'settings/automation'),
    settingsProduct: path(ROOTS_DASHBOARD, 'settings/products'),
    settingsBilling: path(ROOTS_DASHBOARD, 'settings/billing'),
    planSelect: path(ROOTS_DASHBOARD, 'settings/plan-select'),
    optin: path(ROOTS_DASHBOARD, 'optin'),
    tickets: path(ROOTS_DASHBOARD, 'tickets'),
    admin: path(ROOTS_DASHBOARD, 'admin')
  }
};

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  verify: path(ROOTS_AUTH, '/verify')
};
